import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { loginWithGoogle } from 'store/slices/auth';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

const GoogleSignInButton: React.FC = () => {
    const dispatch = useAppDispatch();

    return (
        <Box sx={{ width: '100%', textAlign: 'center', mt: 2 }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                or continue with
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <GoogleLogin
                    onSuccess={(credentialResponse) => {
                        if (credentialResponse.credential) {
                            void dispatch(loginWithGoogle(credentialResponse.credential));
                        }
                    }}
                    onError={() => {
                        console.error('Google sign-in failed');
                    }}
                />
            </Box>
        </Box>
    );
};

export default GoogleSignInButton;
